import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";
import { fmtMoney } from "@/lib/format";
import { Loader2, ShoppingBag, MessageCircle } from "lucide-react";

export default function Catalog() {
  const { companyId } = useParams();
  const [data, setData] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => { api.get(`/public/catalog/${companyId}`).then(({ data }) => setData(data)).catch(() => setErr(true)); }, [companyId]);

  const order = (p) => {
    const phone = (data.company.phone || "").replace(/[^0-9]/g, "");
    const msg = encodeURIComponent(`Bonjour ${data.company.name}, je souhaite commander : ${p.name} (${fmtMoney(p.price, data.company.currency)}).`);
    window.open(phone ? `https://wa.me/${phone}?text=${msg}` : `https://wa.me/?text=${msg}`, "_blank");
  };

  if (err) return <div className="min-h-screen flex items-center justify-center text-muted-foreground">Catalogue introuvable.</div>;
  if (!data) return <div className="min-h-screen flex items-center justify-center"><Loader2 className="w-8 h-8 animate-spin text-primary" /></div>;

  return (
    <div className="min-h-screen bg-background" data-testid="catalog-page">
      <header className="bg-white border-b border-border">
        <div className="max-w-4xl mx-auto px-4 py-5 flex items-center gap-3">
          <div className="w-10 h-10 rounded-md bg-primary text-white flex items-center justify-center"><ShoppingBag className="w-5 h-5" /></div>
          <div><h1 className="font-display text-xl font-bold">{data.company.name}</h1><p className="text-xs text-muted-foreground">Catalogue en ligne — Commandez sur WhatsApp</p></div>
        </div>
      </header>
      <main className="max-w-4xl mx-auto px-4 py-6">
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
          {data.products.map((p) => (
            <div key={p.id} className="border border-border rounded-md bg-white p-4 flex flex-col" data-testid={`catalog-product-${p.id}`}>
              <div className="font-medium">{p.name}</div>
              {p.description && <div className="text-xs text-muted-foreground">{p.description}</div>}
              <div className="text-primary font-display font-bold mt-1">{fmtMoney(p.price, data.company.currency)}</div>
              <div className={`text-xs mt-1 ${p.available ? "text-emerald-600" : "text-rose-500"}`}>{p.available ? "Disponible" : "Rupture"}</div>
              <button onClick={() => order(p)} className="mt-3 rounded-full bg-primary text-white text-sm py-2 flex items-center justify-center gap-1 active:scale-95 transition-transform" data-testid={`order-${p.id}`}>
                <MessageCircle className="w-4 h-4" /> Commander
              </button>
            </div>))}
        </div>
        <p className="text-center text-xs text-muted-foreground mt-8">Propulsé par NATORIQ — Developed by NATHOR TECHNOLOGIES</p>
      </main>
    </div>
  );
}
